<h2>
    @if (iAmSpy) {
        <span>Basisdaten Mandant {{ partnerModel.nachnameOderName1.value }}</span>
    } @else {
        <span>Basisdaten Firma</span>
    }

    <div class="options">
        @if (!iAmSteuerberater) {
            <button class="btn-white-orange" (click)="modify='modifyBasisDaten'">
                <span class="btn-ico-aenderung"></span> <span class="btn-text">Basisdaten ändern</span>
            </button>
        }
    </div>
</h2>
<kunden-basisdaten [partnerModel]="partnerModel"></kunden-basisdaten>

<!-- MODALS -->
@if (modify === 'modifyBasisDaten') {
    <div id="basisdatenAendern" class="modal show">
        <print-partneraenderung [model]="changeProfilPartnerRequest" [invisibleButton]="true"></print-partneraenderung>
        <div class="modalTile">
            <!-- Schliessen Button -->
            <div class="closeMe" data-dismiss="modal" title="Schließen" (click)="modify=null"></div>
            <div class="headline">
                Basisdaten ändern
            </div>
            <div class="modalContent">
                <div class="gridContainer formGrid fitGrid">
                    <div class="row">
                        <div class="cell grid-50">
                            <label for="f_basisdaten_vorname"><strong>Vorname</strong></label>
                            <input type="text"
                                   id="f_basisdaten_vorname"
                                   name="f_basisdaten_vorname"
                                   maxlength="25"
                                   value=""
                                   placeholder="Vorname"
                                   [(ngModel)]="changeProfilPartnerRequest.vorname.recentValue">
                        </div>
                        <div class="cell grid-50">
                            <label for="f_basisdaten_name"><strong>Name</strong></label>
                            <input type="text"
                                   id="f_basisdaten_name"
                                   name="f_basisdaten_name"
                                   maxlength="25"
                                   value=""
                                   placeholder="Name"
                                   [(ngModel)]="changeProfilPartnerRequest.name.recentValue">
                        </div>
                    </div>
                    <div class="row trenner">
                    </div>
                    <div class="row">
                        <div class="cell grid-50">
                            <label for="f_basisdaten_adressfeld1"><strong>Adressfeld 1</strong></label>
                            <input type="text"
                                   id="f_basisdaten_adressfeld1"
                                   name="f_basisdaten_adressfeld1"
                                   maxlength="25"
                                   value=""
                                   placeholder="Adressfeld 1"
                                   [(ngModel)]="changeProfilPartnerRequest.adresszeile1.recentValue">
                        </div>
                        <div class="cell grid-50">
                            <label for="f_basisdaten_adressfeld2"><strong>Adressfeld 2</strong></label>
                            <input type="text"
                                   id="f_basisdaten_adressfeld2"
                                   name="f_basisdaten_adressfeld2"
                                   maxlength="25"
                                   value=""
                                   placeholder="Adressfeld 2"
                                   [(ngModel)]="changeProfilPartnerRequest.adresszeile2.recentValue">
                        </div>
                    </div>
                    <div class="row">
                        <div class="cell grid-50">
                            <label for="f_basisdaten_adressfeld3"><strong>Adressfeld 3</strong></label>
                            <input type="text"
                                   id="f_basisdaten_adressfeld3"
                                   name="f_basisdaten_adressfeld3"
                                   maxlength="25"
                                   value=""
                                   placeholder="Adressfeld 3"
                                   [(ngModel)]="changeProfilPartnerRequest.adresszeile3.recentValue">
                        </div>
                        <div class="cell grid-50">
                            <label for="f_basisdaten_adressfeld4"><strong>Adressfeld 4</strong></label>
                            <input type="text"
                                   id="f_basisdaten_adressfeld4"
                                   name="f_basisdaten_adressfeld4"
                                   maxlength="25"
                                   value=""
                                   placeholder="Adressfeld 4"
                                   [(ngModel)]="changeProfilPartnerRequest.adresszeile4.recentValue">
                        </div>
                    </div>
                    <div class="row trenner">
                    </div>
                    <div class="row">
                        <div class="cell grid-100">
                            <label for="f_basisdaten_telefonnummer"><strong>Telefonnummer (Vorwahl und Rufnummer)</strong></label>
                            <input type="text"
                                   id="f_basisdaten_telefonnummer"
                                   name="f_basisdaten_telefonnummer"
                                   maxlength="25"
                                   value=""
                                   placeholder="Rufnummer"
                                   [(ngModel)]="changeProfilPartnerRequest.telefon.recentValue">
                        </div>
                    </div>
                    <div class="row trenner">
                    </div>
                    <div class="row">
                        <div class="cell grid-50">
                            <label for="f_basisdaten_email1"><strong>E-Mail-Adresse</strong></label>
                            <input type="text"
                                   id="f_basisdaten_email1"
                                   name="f_basisdaten_email1"
                                   maxlength="79"
                                   value=""
                                   placeholder="E-Mail-Adresse"
                                   [(ngModel)]="changeProfilPartnerRequest.email.recentValue"
                                   [class.error]="validationContains('email')">
                            @if (validationContains('email')) {
                                <div
                                    class="errorMessage"
                                    [innerHTML]="validationErrorMessagesFor('email')"></div>
                            }
                        </div>
                        <div class="cell grid-50">
                            <label for="f_basisdaten_email2"><strong>E-Mail-Adresse wiederholen</strong></label>
                            <input type="text"
                                   id="f_basisdaten_email2"
                                   name="f_basisdaten_email2"
                                   maxlength="79"
                                   value=""
                                   placeholder="E-Mail-Adresse wiederholen"
                                   [(ngModel)]="changeProfilPartnerRequest.email.recentValue"
                                   [class.error]="validationContains('email')"
                                   (blur)="validateEmail()">
                            @if (validationContains('email')) {
                                <div
                                    class="errorMessage"
                                    [innerHTML]="validationErrorMessagesFor('email')"></div>
                            }
                        </div>
                    </div>
                    <div class="row trenner">
                    </div>
                    <div class="row">
                        <div class="cell grid-100">
                            <label for="f_basisdaten_freiestextfeld"><strong>Freies Textfeld</strong></label>
                            <textarea id="f_basisdaten_freiestextfeld"
                                      name="f_basisdaten_freiestextfeld"
                                      maxlength="250"
                                      placeholder="Freiwillige Angaben, Hinweise o.ä."
                                      [(ngModel)]="changeProfilPartnerRequest.texteingabe"></textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div class="cell grid-50">
                            <elem-button buttonRole="TERTIARY" class="expand" (click)="modify=null">
                                Abbrechen
                            </elem-button>
                        </div>
                        <div class="cell grid-50">
                            <elem-button buttonRole="PRIMARY" class="expand" (click)="changePartnerData()">
                                Daten ändern
                            </elem-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
